import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Dev-only: the PayPal SDK can emit an opaque cross-origin "Script error." that
// CRA's react-error-overlay renders as a full-screen overlay. It is harmless (the
// PayPal buttons and Pay Later messaging render fine underneath) and never appears
// in the production build, which ships no overlay. Turn off the dev overlay so it
// does not block checkout; errors still log to the console.
if (process.env.NODE_ENV === "development") {
  import("react-error-overlay")
    .then((m) => m.stopReportingRuntimeErrors && m.stopReportingRuntimeErrors())
    .catch(() => {});
}


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
